import { Box, Container, Typography, Paper } from "@mui/material";
import { Link } from "react-router-dom";
import { seoArticles } from "../../seo/articleCatalog";
import classes from "../../style";

export const Articles: React.FC = () => {
    return (
        <Box sx={{ ...classes.defiscalisation, padding: "2rem 0" }}>
            <Container maxWidth="lg">
                <Typography variant="h4" component="h1" mt={5} gutterBottom align="center">
                    Articles coaching sportif à domicile
                </Typography>
                <Box
                    sx={{
                        display: "grid",
                        gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
                        gap: "1.5rem",
                        marginTop: "1rem",
                    }}
                >
                    {seoArticles.map((article) => (
                        <Paper
                            key={article.id}
                            elevation={3}
                            sx={{
                                padding: "1.5rem",
                                borderRadius: "16px",
                                transition: "transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out",
                                "&:hover": {
                                    transform: "scale(1.05)",
                                    boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.2)",
                                },
                            }}
                        >
                            <Link
                                to={article.path}
                                style={{
                                    textDecoration: "none",
                                    color: "inherit",
                                }}
                            >
                                <Typography variant="h6" component="h2" gutterBottom>
                                    {article.listTitle}
                                </Typography>
                                <Typography variant="body2" color="textSecondary">
                                    {article.description}
                                </Typography>
                            </Link>
                        </Paper>
                    ))}
                </Box>
            </Container>
        </Box>
    );
};

